/**
 * Align the main navigation on the homepage sticky on the side on desktop
 */
(function() {

	var siteNavigation = document.querySelector(".site-navigation-holder");

	if(!siteNavigation) {
		return;
	}

	if (siteNavigation.classList.contains('align-navigation-for-subpage')) {
		return;
	}

	var scrollPosition = false;



	window.addEventListener('scroll', onScroll);
	window.addEventListener('resize', onResize);

	function onScroll() {
		requestAnimationFrame(function() {
  			var newScrollPosition = window.pageYOffset;

			if(scrollPosition === newScrollPosition) {
				return;
			}
			scrollPosition = newScrollPosition;

			updateNavigationPosition();
		});
	}

	function onResize() {
		requestAnimationFrame(function() {
			updateNavigationPosition();
		});
	}

	function updateNavigationPosition() {

		var vieportHeightHalf = window.innerHeight / 2;
		var teaserImageSlider = document.querySelector(".teaser-slider-image-holder");
		var teaserImageHeight = teaserImageSlider ? teaserImageSlider.getBoundingClientRect().height : 0;
		var logoRect = document.querySelector(".logo-holder").getBoundingClientRect();
		var logoHeight = logoRect.height;
		var logoOffsetTop = logoRect.top;
		var logoBoundingBox = logoHeight + logoOffsetTop;
		var siteScrollPosition = window.pageYOffset;
		var stickAfterZero = teaserImageHeight - logoBoundingBox - siteScrollPosition;

		if (stickAfterZero >= 0) {
			// the navigation is not sticky, show it for the lower half of the screen
			siteNavigation.style.bottom = siteScrollPosition + 'px';
		} else if (stickAfterZero < 0) {
			siteNavigation.style.bottom = (teaserImageHeight - logoBoundingBox) + "px";
		};
	}

	updateNavigationPosition();

}());
